import React from 'react'
import { api } from 'core/api/ConnectionManager'

export interface NewFeature {
    id: number
    images: {
        left: string
        right: string
    }
    title: string
    text: string
    icon: string
}

export interface AppFeaturesMethodsProps {
    newFeatures: NewFeature[]
    lang: string
    clearFeatures: () => void
}

export interface AppFeaturesMethodsState {
    open: boolean
}

class AppFeaturesMethods extends React.Component<AppFeaturesMethodsProps, AppFeaturesMethodsState> {
    static defaultProps: Partial<AppFeaturesMethodsProps> = {
        newFeatures: [],
        lang: 'ru',
    }

    state: AppFeaturesMethodsState = {
        open: false,
    }

    onViewed = () => {
        const p_ = this.props

        const newFeatureId = p_.newFeatures.map((feature) => feature.id)

        api.send('newFeatureViewed', { newFeatureId }).then(() => {
            this.setState({ open: false })
            p_.clearFeatures()
        })
    }
}

export default AppFeaturesMethods
